import React from "react";
import {observable} from "mobx";
import axios from "axios";

export default class ImportacaoNotasAdicionarStore {

    @observable listaChaves;
    @observable listaMsgs;

    @observable salvando;
    @observable aguardandoSalvar;
    @observable achouErro;

    constructor(service) {
        this.listaChaves = [{ chave: "", tipoServico: false, tipoNfe: false  }];
        this.listaMsgs = [false];

        this.salvando = false;
        this.aguardandoSalvar = false;
        this.achouErro = false;

        this.service = service;
    };

    adicionarChave = () => {
        this.listaChaves.push({ chave: "", tipoServico: false, tipoNfe: false });
        this.listaMsgs.push(false)
    };

    changeChave = (event, x) => {
        this.listaChaves[x].chave = event.target.value.toUpperCase();
    };

    removerUltima = () => {
        this.listaChaves = this.listaChaves.splice(0, this.listaChaves.length-1)
    };

    salvarChaves = (blId, protocoloId, callback, fecharModal) => {
        this.achouErro = false;
        this.aguardandoSalvar = true;

        this.salvando = [];
        this.listaChaves.map(c => { this.salvando.push({finalizado: false})});
        Promise.all([
            this.listaChaves.map((c, x) => {
                return this.service.salvarNota(c.tipoServico.value, c.chave, blId, protocoloId,c.tipoNfe.value).then(response => {
                    this.salvando[x].finalizado = true;
                    if (!response.data.Sucesso) {
                        this.achouErro = true;
                        this.listaMsgs[x] = response.data.MensagemErro;
                    }
                }).catch(error => {
                    console.log(error)
                    this.achouErro = true;
                })
            }),
        ]).then(() => {
            this.validacao(callback, fecharModal);
        }).catch((error) => { console.log(error); this.aguardandoSalvar = false; });
    };

    validacao = (callback, fecharModal) => {
        if (this.salvando.find(s => s.finalizado===false)) {
            setTimeout(function() {
                this.validacao(callback, fecharModal);
            }.bind(this), 1000);
        } else {
            this.aguardandoSalvar = false;
            if (!this.achouErro) {
                callback();
                fecharModal();
            }
        }
    };

    excluirNotasChaves = (index) => {
        if (this.listaChaves && this.listaChaves.length > 0)
        {
            this.listaChaves.splice(index,1);
        }
    }

    setTipo = (event, x) => {
        if (event)
            this.listaChaves[x].tipoServico = event;
        else
            this.listaChaves[x].tipoServico = false;
    };
    setTipo = (event, x) => {
        if (event)
            this.listaChaves[x].tipoServico = event;
        else
            this.listaChaves[x].tipoServico = false;
    };
    setTipoNfe = (event, x) => {
        if (event)
            this.listaChaves[x].tipoNfe = event;
        else
            this.listaChaves[x].tipoNfe = false;
    };
};


// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/stores/ImportacaoNotasAdicionarStore.js